import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('rr_user')); } catch { return null; }
  });

  const login = useCallback(async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    const { token, user: userData } = res.data;
    localStorage.setItem('rr_token', token);
    localStorage.setItem('rr_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('rr_token');
    localStorage.removeItem('rr_user');
    setUser(null);
  }, []);

  const updateUser = useCallback((data) => {
    const updated = { ...user, ...data };
    localStorage.setItem('rr_user', JSON.stringify(updated));
    setUser(updated);
  }, [user]);

  // Role helpers
  const isAdmin = user?.role === 'admin';
  const isManager = user?.role === 'manager' || isAdmin;
  const isSupervisor = user?.role === 'supervisor' || isManager;
  const canManageReports = isSupervisor;
  const canSeeOrgDashboard = isManager;
  const canManageUsers = isAdmin;

  return (
    <AuthContext.Provider value={{
      user, login, logout, updateUser, isAuthenticated: !!user,
      isAdmin, isManager, isSupervisor, canManageReports, canSeeOrgDashboard, canManageUsers
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
